import { ComponentType, FC, ReactNode } from 'react';
import { Cookies, CookiesProvider } from 'react-cookie';
import { PlatformConfigProvider } from '@belong/device-bridge';
import { CorrelationIdContext } from '@belong/user';
import { Provider as AnalyticsEvents, useAnalyticsEvents } from './analyticsEvents';
import { Provider as Authentication } from './authentication';
import { Provider as DeviceCapabilities } from './deviceCapabilities';
import { Provider as Footer } from './footer';
import { Provider as Header } from './header';
import { Provider as PageMeta } from './pageMeta';
import { Provider as Products } from './products';
import { Provider as Runtime } from './runtime';
import { Provider as User } from './user';

interface IProviderProps {
  cookies: Cookies;
  correlationId: string;
  children: ReactNode;
  additionalProviders?: ComponentType<any>[];
}

const Providers: FC<IProviderProps> = ({ children, cookies, correlationId, additionalProviders = [] }) => {
  let innerContent = (
    <Header>
      <Footer>
        <AnalyticsEvents>{children}</AnalyticsEvents>
      </Footer>
    </Header>
  );

  additionalProviders.forEach(Provider => {
    innerContent = <Provider>{innerContent}</Provider>;
  });

  const wrappedContent = (
    <CorrelationIdContext.Provider value={correlationId}>
      <CookiesProvider cookies={cookies}>
        <PlatformConfigProvider cookies={cookies}>
          <Authentication>
            <DeviceCapabilities>
              <User>
                <PageMeta>
                  <Runtime>
                    <Products>{innerContent}</Products>
                  </Runtime>
                </PageMeta>
              </User>
            </DeviceCapabilities>
          </Authentication>
        </PlatformConfigProvider>
      </CookiesProvider>
    </CorrelationIdContext.Provider>
  );

  return wrappedContent;
};

export { Providers as default, useAnalyticsEvents };
